import { CollectionViewer } from "@angular/cdk/collections";
import { select, Store } from "@ngrx/store";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";
import { AppState } from "../../reducers";
import { BaseDataSource } from "../../_base/crud";
import { selectAssetClassHouseInStore, selectAssetClassHousePageLoading, selectAssetClassHouseShowInitWaitingMessage } from "../_selectors/asset-class-house.selectors";
import { tenureAdder } from "./tenure_extension";

export class AssetClassHouseDataSource extends BaseDataSource {
    trashed = 0;

    constructor(
        private store: Store<AppState>
    ) {
        super();

        this.loading$ = this.store.pipe(
            select(selectAssetClassHousePageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectAssetClassHouseShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectAssetClassHouseInStore)
        ).subscribe(response => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.trashed = response.trashed;
            this.entitySubject.next(response.items.map(e => tenureAdder(e)));
        })
    }
}